// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider--3ZTZZ"};